import { useAnswer } from "../../features/questionnaire";

const POLICYHOLDER_SECTION_ID = "Policyholder information";
const BUSINESS_OWNER_QUESTION_NAME = "Business owner";

export const useShouldHideSectionTitle = (id: string): boolean => {
  const businessOwner = useAnswer(BUSINESS_OWNER_QUESTION_NAME);

  if (
    id === POLICYHOLDER_SECTION_ID &&
    (businessOwner === "yes" || !businessOwner)
  )
    return true;
  // Add more rules

  return false;
};
